/* Configuratore "Che strumento mi serve?" — Onautica, 05/09/2026.
   Sei domande, poi tre proposte prese dal catalogo vivo. Prezzo e disponibilità si leggono
   al momento da /products/<handle>.js: nella pagina non è scritto nessun prezzo. */
(function () {
  'use strict';
  var radice = document.getElementById('cfg');
  if (!radice) return;
  var pannello = document.getElementById('cfg-pannello');
  var avanz = document.getElementById('cfg-avanz');

  var DOMANDE = [
    { id: 'barca', tit: 'Che barca hai?',
      aiuto: 'Serve a capire quanto schermo ci sta in consolle.',
      opts: [
        { v: 'gommone', t: 'Gommone o open fino a 6 metri', d: 'Consolle piccola, si naviga sotto costa' },
        { v: 'media', t: 'Barca da 6 a 9 metri', d: 'Cabinato, day cruiser, open grande' },
        { v: 'grande', t: 'Barca da 9 a 14 metri', d: 'Plancia vera, spesso due strumenti' },
        { v: 'vela', t: 'Barca a vela', d: 'Scafo dislocante, strumenti di rete' }
      ] },
    { id: 'uso', tit: 'Cosa ci fai, soprattutto?',
      aiuto: 'È la domanda che pesa di più: chi pesca e chi naviga hanno bisogno di due cose diverse.',
      opts: [
        { v: 'navigare', t: 'Navigo e basta', d: 'Rotte, porti, profondità per non toccare' },
        { v: 'costiera', t: 'Pesco sotto costa', d: 'Secche, relitti, fondali fino a 100-150 m' },
        { v: 'traina', t: 'Pesco a traina o in altura', d: 'Fondali alti, banchi di pesce' },
        { v: 'misto', t: "Un po' e un po'", d: 'Gite in famiglia e qualche battuta di pesca' }
      ] },
    { id: 'carte', tit: 'Ti serve la carta nautica a bordo?',
      aiuto: 'È la differenza fra un ecoscandaglio e un chartplotter: il primo ti dice quanto è profondo, il secondo ti disegna anche la costa e i porti.',
      opts: [
        { v: 'si', t: 'Sì, voglio vedere la costa e i porti', d: 'Chartplotter con cartografia inclusa' },
        { v: 'no', t: 'No, mi basta vedere il fondale', d: 'Ecoscandaglio con GPS: segna i punti e ci torni' },
        { v: 'nonso', t: 'Non lo so', d: 'Decidi tu in base al resto' }
      ] },
    { id: 'schermo', tit: 'Quanto lo vuoi grande?',
      aiuto: 'Più grande si legge meglio col sole e si vedono carta e sonar affiancati. Ma deve starci in consolle.',
      opts: [
        { v: 'piccolo', t: 'Piccolo, 4-5 pollici', d: 'Consolle stretta o secondo strumento' },
        { v: 'medio', t: 'Medio, 6-7 pollici', d: 'La misura che scelgono in tanti' },
        { v: 'grande', t: 'Grande, 9 pollici o più', d: 'Plancia ampia' },
        { v: 'nonso', t: 'Dimmelo tu', d: 'In base alla barca' }
      ] },
    { id: 'trasduttore', tit: 'Hai già un trasduttore a bordo?',
      aiuto: 'È il pezzo sotto lo scafo che manda e riceve il segnale del sonar. Se ne hai già uno buono si può riusare e si risparmia.',
      opts: [
        { v: 'niente', t: 'No, parto da zero', d: 'Meglio prendere lo strumento col trasduttore incluso' },
        { v: 'ho', t: 'Sì, ne ho uno che va bene', d: 'Ti propongo le versioni senza trasduttore' },
        { v: 'nonso', t: 'Non lo so', d: 'Nel dubbio te lo propongo incluso' }
      ] },
    { id: 'spesa', tit: 'Quanto vorresti spenderci?',
      aiuto: 'Strumento e trasduttore insieme. Se sforare di poco cambia molto te lo dico.',
      opts: [
        { v: 'basso', t: 'Fino a 300 €', d: "L'essenziale, fatto bene" },
        { v: 'medio', t: 'Da 300 a 800 €', d: 'La fascia con più scelta' },
        { v: 'alto', t: 'Da 800 a 1.500 €', d: 'Schermi grandi, sonar completo' },
        { v: 'aperto', t: 'Oltre 1.500 €', d: 'Voglio la soluzione migliore' }
      ] }
  ];

  var FASCIA = { basso: [0, 300], medio: [300, 800], alto: [800, 1500], aperto: [1500, 99999] };
  var PERCHE = {
    striker: 'Ecoscandaglio con GPS: segna i punti e ci torni, ma non disegna la costa.',
    echomap: 'Chartplotter con la cartografia inclusa: carta nautica e sonar sullo stesso schermo.',
    ultra: 'Schermo grande e sonar completo: carta e fondale affiancati senza strizzare gli occhi.',
    gpsmap: 'La famiglia che regge il resto della barca: si può aggiungere radar e pilota.',
    eagle: 'Cartografia C-MAP inclusa, comandi semplici: pensato per chi pesca senza complicarsi.',
    elitefs: 'Per chi pesca: interfaccia semplice e predisposto per il sonar in tempo reale.',
    hdspro: 'Il livello alto di Lowrance: schermo grande e sonar per chi sta fuori tutto il giorno.'
  };

  var stato = { i: 0, risposte: {}, fine: false, catalogo: null };

  function pollici(r) {
    if (r.schermo === 'piccolo') return [3, 5];
    if (r.schermo === 'medio') return [6, 7];
    if (r.schermo === 'grande') return [9, 16];
    if (r.barca === 'gommone') return [3, 7];
    if (r.barca === 'media') return [5, 9];
    if (r.barca === 'grande') return [7, 16];
    return [5, 9];
  }

  function punti(p, r) {
    var s = 0, note = [];
    var f = pollici(r);
    if (p.pollici) { if (p.pollici >= f[0] && p.pollici <= f[1]) s += 3; else s -= Math.min(6, Math.abs(p.pollici < f[0] ? f[0] - p.pollici : p.pollici - f[1]) * 1.5); }

    if (r.carte === 'si') { s += p.carte ? 3 : -12; }
    else if (r.carte === 'no') { s += p.carte ? -1 : 3; }

    if (r.uso === 'navigare') { s += p.carte ? 3 : -8; }
    if (r.uso === 'costiera') { if (p.sonar.indexOf('side') > -1) s += 3; if (p.carte) s += 1; }
    if (r.uso === 'traina') { if (p.sonar.indexOf('side') > -1) s += 2; if (p.pollici >= 9) s += 2; }
    if (r.uso === 'misto') { if (p.carte) s += 2; if (p.sonar.indexOf('clear') > -1) s += 1; }

    if (r.trasduttore === 'ho') { if (p.trasduttore_incluso === false) s += 3; if (p.trasduttore_incluso === true) s -= 2; }
    else { if (p.trasduttore_incluso === true) s += 3; if (p.trasduttore_incluso === false) { s -= 1; note.push('Questa è la versione senza trasduttore: va aggiunto a parte.'); } }

    var b = FASCIA[r.spesa], prezzo = p.prezzo_da;
    if (prezzo >= b[0] && prezzo <= b[1]) s += 4;
    else if (prezzo > b[1]) {
      var sfora = (prezzo - b[1]) / Math.max(1, b[1]);
      s -= sfora > 0.6 ? 10 : sfora > 0.25 ? 5 : 2;
      if (sfora <= 0.25) note.push('Costa un po’ più di quanto avevi detto, ma è il salto che cambia le cose.');
    } else { s -= 2; }
    return { s: s, note: note };
  }

  function scegli(r) {
    var lista = stato.catalogo.strumenti.map(function (p) {
      var x = punti(p, r); return Object.assign({}, p, { punti: x.s, note: x.note });
    }).sort(function (a, b) { return b.punti - a.punti; });

    var scelti = [], marche = {}, modelli = {};
    lista.forEach(function (p) {
      if (scelti.length >= 3) return;
      var modello = p.titolo.replace(/\s*(con|senza)\s+trasduttore.*/i, '').trim().toLowerCase();
      if (modelli[modello]) return;                       // mai la stessa scheda con/senza
      if (marche[p.marca] >= 2 && scelti.length < 3) return; // massimo 2 della stessa marca
      modelli[modello] = 1; marche[p.marca] = (marche[p.marca] || 0) + 1;
      scelti.push(p);
    });
    return scelti;
  }

  // trasduttore da proporre a parte: si sceglie fra quelli che abbiamo, per tipo di sonar
  function trasduttorePer(p) {
    var t = stato.catalogo.trasduttori.filter(function (x) { return x.marca === p.marca; });
    if (!t.length) return null;
    var vuoleSide = p.sonar.indexOf('side') > -1;
    var buoni = t.filter(function (x) { return vuoleSide ? x.sonar.indexOf('side') > -1 : true; });
    return (buoni.length ? buoni : t).sort(function (a, b) { return a.prezzo_da - b.prezzo_da; })[0];
  }

  function euro(n) { return n.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }

  /* ── Tabella di confronto (Daniele, 07/09/2026) ────────────────────────────
     «a fine scelta vorrei che facessi una tabella sotto le scelte con caratteristiche e
      pallini per vedere chi ha quella caratteristica e chi no, e a fine tabella aggiungi
      al carrello».
     Le righe a pallino sono solo quelle vere SÌ/NO. Schermo, marca e prezzo restano
     valori scritti: un pallino su «7 pollici» non vorrebbe dire niente.
     Tabella secondo la regola di casa per il cellulare (CLAUDE.md): contenitore che
     scorre, table-layout auto, min-width, celle corte che non vanno a capo. */
  var CARATTERISTICHE = [
    { k: 'carte', t: 'Carta nautica inclusa',
      aiuto: 'Ti disegna costa, porti e secche. Senza, vedi solo il fondale.',
      test: function (p) { return p.carte === true; } },
    { k: 'trasd', t: 'Trasduttore incluso',
      aiuto: 'Il sensore sotto lo scafo. Se manca va comprato a parte e costa.',
      test: function (p) { return p.trasduttore_incluso === true; } },
    { k: 'chirp', t: 'Sonar CHIRP',
      aiuto: 'Legge il fondale con più nitidezza dei sonar tradizionali.',
      test: function (p) { return p.sonar.indexOf('chirp') > -1; } },
    { k: 'clear', t: 'Fondale in verticale',
      aiuto: 'Immagine quasi fotografica di quello che sta sotto la barca.',
      test: function (p) { return p.sonar.indexOf('clear') > -1; } },
    { k: 'side', t: 'Sonar laterale',
      aiuto: 'Guarda a destra e a sinistra dello scafo: serve per cercare secche e relitti.',
      test: function (p) { return p.sonar.indexOf('side') > -1; } }
  ];

  function pallino(vero) {
    return vero
      ? '<span class="cfg-si" role="img" aria-label="sì">●</span>'
      : '<span class="cfg-no" role="img" aria-label="no">○</span>';
  }

  function tabellaConfronto(scelti) {
    var intest = scelti.map(function (p) {
      return '<th scope="col"><span class="cfg-th-marca">' + p.marca + '</span>' +
        '<a href="/products/' + p.handle + '">' + p.titolo.replace(/\s*[–-]\s*.*$/, '') + '</a></th>';
    }).join('');

    var righe = CARATTERISTICHE.map(function (c) {
      var celle = scelti.map(function (p) {
        return '<td class="cfg-td-pallino">' + pallino(c.test(p)) + '</td>';
      }).join('');
      return '<tr><th scope="row">' + c.t + '<small>' + c.aiuto + '</small></th>' + celle + '</tr>';
    }).join('');

    var schermo = '<tr><th scope="row">Schermo</th>' + scelti.map(function (p) {
      return '<td>' + (p.pollici ? String(p.pollici).replace('.', ',') + '"' : '—') + '</td>';
    }).join('') + '</tr>';

    var prezzo = '<tr class="cfg-riga-prezzo"><th scope="row">Prezzo</th>' + scelti.map(function (p) {
      return '<td data-tprezzo="' + p.handle + '">—</td>';
    }).join('') + '</tr>';

    var carrello = '<tr class="cfg-riga-carrello"><th scope="row"></th>' + scelti.map(function (p) {
      return '<td><div data-carrello="' + p.handle + '"><span class="cfg-attesa-mini">…</span></div></td>';
    }).join('') + '</tr>';

    return '<h3 class="cfg-tit-tab">Le tre a confronto</h3>' +
      '<p class="cfg-aiuto">Il pallino pieno vuol dire che ce l’ha, quello vuoto che non ce l’ha.</p>' +
      '<div class="cfg-tab-wrap"><table class="cfg-tab">' +
      '<thead><tr><th scope="col"></th>' + intest + '</tr></thead>' +
      '<tbody>' + schermo + righe + prezzo + carrello + '</tbody></table></div>';
  }

  /* Aggiunta al carrello. Un solo formato disponibile → si aggiunge davvero; più formati
     (misure, con/senza trasduttore) → si manda alla scheda, perché sceglierlo qui vorrebbe
     dire indovinare quale. */
  function bottoneCarrello(box, dati, handle) {
    var disponibili = (dati && dati.variants || []).filter(function (v) { return v.available; });
    if (!dati || !dati.variants || !dati.variants.length) {
      box.innerHTML = '<a class="cfg-btn cfg-btn-scheda" href="/products/' + handle + '">Vedi la scheda</a>';
      return;
    }
    if (!disponibili.length) {
      box.innerHTML = '<a class="cfg-btn cfg-btn-scheda" href="/products/' + handle + '">Non ordinabile · scrivici</a>';
      return;
    }
    if (disponibili.length > 1) {
      box.innerHTML = '<a class="cfg-btn cfg-btn-scheda" href="/products/' + handle + '">Scegli il formato</a>';
      return;
    }
    var v = disponibili[0];
    box.innerHTML = '<button type="button" class="cfg-btn cfg-btn-carrello">Aggiungi al carrello</button>';
    box.querySelector('button').addEventListener('click', function () {
      var b = this;
      b.disabled = true; b.textContent = 'Aggiungo…';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
      }).then(function (r) { if (!r.ok) throw new Error('no'); return r.json(); })
        .then(function () {
          box.innerHTML = '<span class="cfg-aggiunto">Aggiunto</span>' +
            '<a class="cfg-vai-carrello" href="/cart">Vai al carrello</a>';
        })
        .catch(function () {
          b.disabled = false; b.textContent = 'Non riesco: apri la scheda';
          b.classList.add('cfg-btn-scheda');
          b.addEventListener('click', function () { window.location.href = '/products/' + handle; });
        });
    });
  }

  // legge prezzo e disponibilità dal vivo (niente prezzi scritti dentro la pagina)
  function dalVivo(handle) {
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }

  function disegnaDomanda() {
    var q = DOMANDE[stato.i];
    var scelta = stato.risposte[q.id];
    avanz.style.width = Math.round((stato.i / DOMANDE.length) * 100) + '%';
    pannello.innerHTML =
      '<p class="cfg-passo">Domanda ' + (stato.i + 1) + ' di ' + DOMANDE.length + '</p>' +
      '<h2>' + q.tit + '</h2><p class="cfg-aiuto">' + q.aiuto + '</p><div class="cfg-opzioni">' +
      q.opts.map(function (o) {
        return '<button type="button" class="cfg-opz" aria-pressed="' + (scelta === o.v) + '" data-v="' + o.v + '">' +
          '<b>' + o.t + '</b><span>' + o.d + '</span></button>';
      }).join('') + '</div><div class="cfg-azioni">' +
      (stato.i > 0 ? '<button type="button" class="cfg-btn chiaro" data-az="indietro">Indietro</button>' : '') +
      '</div>';

    Array.prototype.forEach.call(pannello.querySelectorAll('.cfg-opz'), function (b) {
      b.addEventListener('click', function () {
        stato.risposte[q.id] = b.getAttribute('data-v');
        if (stato.i < DOMANDE.length - 1) stato.i++; else stato.fine = true;
        disegna();
      });
    });
    var ind = pannello.querySelector('[data-az="indietro"]');
    if (ind) ind.addEventListener('click', function () { stato.i--; disegna(); });
  }

  function etichetta(id) {
    for (var i = 0; i < DOMANDE.length; i++) {
      if (DOMANDE[i].id !== id) continue;
      for (var j = 0; j < DOMANDE[i].opts.length; j++) {
        if (DOMANDE[i].opts[j].v === stato.risposte[id]) return DOMANDE[i].opts[j].t;
      }
    }
    return null;
  }

  function disegnaEsito() {
    avanz.style.width = '100%';
    var scelti = scegli(stato.risposte);
    var chip = Object.keys(stato.risposte).map(etichetta).filter(Boolean)
      .map(function (t) { return '<li>' + t + '</li>'; }).join('');

    pannello.innerHTML =
      '<h2>Ecco cosa ti consiglio</h2>' +
      '<p class="cfg-aiuto">Tre strumenti scelti su quello che mi hai detto. Il prezzo è quello di adesso, ' +
      'letto dal catalogo mentre leggi questa pagina.</p>' +
      '<ul class="cfg-scelte">' + chip + '</ul>' +
      '<div class="cfg-griglia" id="cfg-griglia">' + scelti.map(function (p, i) {
        return '<article class="cfg-prod' + (i === 0 ? ' primo' : '') + '" data-h="' + p.handle + '">' +
          '<div class="cfg-banda">' + (i === 0 ? 'La scelta che consiglio' : i === 1 ? 'La seconda strada' : "Un'alternativa") + '</div>' +
          '<div class="cfg-corpo">' +
            '<span class="cfg-marca">' + p.marca + '</span>' +
            '<h3><a href="/products/' + p.handle + '">' + p.titolo + '</a></h3>' +
            '<p class="cfg-perche">' + (PERCHE[p.famiglia] || '') + '</p>' +
            '<ul class="cfg-righe">' +
              (p.pollici ? '<li><span class="k">Schermo</span><span>' + String(p.pollici).replace('.', ',') + '"</span></li>' : '') +
              '<li><span class="k">Sonar</span><span>' + (p.trasduttore_incluso === false ? 'dipende dal trasduttore' : p.sonar.map(function (s) { return s === 'chirp' ? 'CHIRP' : s === 'clear' ? 'fondale in verticale' : 'anche laterale'; }).join(', ')) + '</span></li>' +
              '<li><span class="k">Carta nautica</span><span>' + (p.carte ? 'inclusa' : 'no') + '</span></li>' +
            '</ul>' +
            '<p class="cfg-prezzo" data-prezzo>—</p>' +
            '<p class="cfg-stato" data-stato></p>' +
            (p.note.length ? '<p class="cfg-perche">' + p.note[0] + '</p>' : '') +
            '<p class="cfg-serve" data-serve></p>' +
          '</div></article>';
      }).join('') + '</div>' +
      (scelti.some(function (p) { return !p.carte; }) ?
        '<p class="cfg-avviso">Fra le proposte c’è un <b>ecoscandaglio</b>, non un chartplotter: ha il GPS e segna i punti, ' +
        'ma non ti disegna la costa. Se ti serve la carta nautica, guarda le altre due.</p>' : '') +
      tabellaConfronto(scelti) +
      '<div class="cfg-azioni"><button type="button" class="cfg-btn chiaro" data-az="rifai">Ricomincia</button></div>' +
      '<p class="cfg-nota">Il consiglio parte dalla barca e dall’uso, non dal prezzo: la misura dello schermo la decide ' +
      'la consolle, il tipo di sonar lo decide cosa ci fai. Il trasduttore vale spesso quanto lo strumento. ' +
      'Se hai un dubbio scrivici: ti rispondiamo noi, non un programma.</p>';

    pannello.querySelector('[data-az="rifai"]').addEventListener('click', function () {
      stato.i = 0; stato.risposte = {}; stato.fine = false; disegna();
    });

    // prezzo, disponibilità e foto dal vivo + il trasduttore da aggiungere
    scelti.forEach(function (p) {
      var card = pannello.querySelector('.cfg-prod[data-h="' + p.handle + '"]');
      if (!card) return;
      var t = trasduttorePer(p);
      var serve = card.querySelector('[data-serve]');
      if (p.trasduttore_incluso === true) serve.innerHTML = '<b>Il trasduttore è già incluso.</b>';
      else if (t) serve.innerHTML = '<b>Ti serve anche il trasduttore</b>, che si somma: <a href="/products/' + t.handle + '">' + t.titolo + '</a>.';
      else serve.innerHTML = '<b>Il trasduttore si sceglie sulla scheda</b>, insieme allo strumento.';

      dalVivo(p.handle).then(function (d) {
        var pr = card.querySelector('[data-prezzo]'), st = card.querySelector('[data-stato]');
        // stessa lettura serve alla tabella di confronto: prezzo e bottone del carrello
        var cellaT = pannello.querySelector('[data-tprezzo="' + p.handle + '"]');
        var boxCar = pannello.querySelector('[data-carrello="' + p.handle + '"]');
        if (boxCar) bottoneCarrello(boxCar, d, p.handle);
        if (!d || !d.variants || !d.variants.length) {
          pr.textContent = 'vedi il prezzo sulla scheda';
          if (cellaT) cellaT.textContent = '—';
          return;
        }
        var vv = d.variants.filter(function (v) { return v.available; });
        var usa = vv.length ? vv : d.variants;
        var min = Math.min.apply(null, usa.map(function (v) { return v.price / 100; }));
        pr.textContent = (usa.length > 1 ? 'da ' : '') + euro(min);
        if (cellaT) cellaT.textContent = (usa.length > 1 ? 'da ' : '') + euro(min);
        if (vv.length) { st.className = 'cfg-stato si'; st.textContent = 'Si può ordinare'; }
        else { st.className = 'cfg-stato no'; st.textContent = 'In questo momento non è ordinabile: scrivici e ti diciamo i tempi.'; }
        if (d.featured_image) {
          var img = new Image();
          img.className = 'cfg-foto'; img.loading = 'lazy'; img.alt = d.title;
          img.src = d.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2');
          card.insertBefore(img, card.querySelector('.cfg-corpo'));
        }
      });
    });
  }

  function disegna() { if (stato.fine) disegnaEsito(); else disegnaDomanda(); window.scrollTo({ top: radice.offsetTop - 20, behavior: 'smooth' }); }

  fetch(radice.getAttribute('data-catalogo'))
    .then(function (r) { return r.json(); })
    .then(function (dati) {
      stato.catalogo = dati;
      if (!dati.strumenti || !dati.strumenti.length) throw new Error('catalogo vuoto');
      disegna();
    })
    .catch(function () {
      pannello.innerHTML = '<p class="cfg-attesa">Non riesco a leggere il catalogo in questo momento. ' +
        'Scrivici su WhatsApp e ti diciamo noi quale strumento prendere.</p>';
    });
})();
